export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7469.5af1e84d.jpg";